import { render, staticRenderFns } from "./NotLoginBottom.vue?vue&type=template&id=16fad70c&scoped=true&"
import script from "./NotLoginBottom.vue?vue&type=script&lang=js&"
export * from "./NotLoginBottom.vue?vue&type=script&lang=js&"
import style0 from "./NotLoginBottom.vue?vue&type=style&index=0&id=16fad70c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fad70c",
  null
  
)

export default component.exports